import { Common, Primary, Success, ErrorToken, Warning } from "../../foundations/palette.es.js";
import { Spacing } from "../../foundations/spacing.es.js";
import { typography } from "../../foundations/typography.es.js";
import { Alignment } from "../../foundations/alignment.es.js";
const TYPOGRAPHY_SUCCESS_COLOR = "#1E4620";
const TYPOGRAPHY_ERROR_COLOR = "#5F2120";
const TYPOGRAPHY_WARNING_COLOR = "#663C00";
const SUCCESS_SHADE_COLOR = "#EDF7ED";
const ERROR_SHADE_COLOR = "#FDEDED";
const WARNING_SHADE_COLOR = "#FFF4E5";
const INFO_SHADE_COLOR = "#F1F4FC";
const alertStylesOverride = {
  root: {
    width: "100%",
    padding: `${Spacing["500"]} ${Spacing["1000"]}`
  },
  filledWarning: {
    color: Common.white.main
  },
  filledInfo: {
    color: Common.white.main,
    backgroundColor: Primary.main
  },
  standardSuccess: {
    backgroundColor: SUCCESS_SHADE_COLOR,
    color: TYPOGRAPHY_SUCCESS_COLOR
  },
  standardError: {
    backgroundColor: ERROR_SHADE_COLOR,
    color: TYPOGRAPHY_ERROR_COLOR
  },
  standardWarning: {
    backgroundColor: WARNING_SHADE_COLOR,
    color: TYPOGRAPHY_WARNING_COLOR
  },
  standardInfo: {
    backgroundColor: INFO_SHADE_COLOR,
    color: Primary.dark,
    "& .MuiAlert-icon": {
      color: Primary.dark
    }
  },
  outlinedSuccess: {
    borderColor: Success.main,
    color: TYPOGRAPHY_SUCCESS_COLOR
  },
  outlinedError: {
    borderColor: ErrorToken.main,
    color: TYPOGRAPHY_ERROR_COLOR
  },
  outlinedWarning: {
    borderColor: Warning.main,
    color: TYPOGRAPHY_WARNING_COLOR
  },
  outlinedInfo: {
    borderColor: Primary.main,
    color: Primary.dark,
    "& .MuiAlert-icon": {
      color: Primary.dark
    }
  },
  icon: {
    alignItems: Alignment.center
  },
  message: {
    ...typography.body2
  }
};
export {
  alertStylesOverride
};
//# sourceMappingURL=styles.es.js.map
